import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class ExcelMaterialImport_ds_get_owners_by_lookupcodesService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { ownerLookupcodes: string[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Name?: string, Projects?: { Id?: number, LookupCode?: string, Name?: string }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.ownerLookupcodes)) {
      missingRequiredInParams.push('\'ownerLookupcodes\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/ExcelMaterialImport/datasources/ds_get_owners_by_lookupcodes/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { ownerLookupcodes: string[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Name?: string, Projects?: { Id?: number, LookupCode?: string, Name?: string }[] }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.ownerLookupcodes)) {
      missingRequiredInParams.push('\'ownerLookupcodes\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/ExcelMaterialImport/datasources/ds_get_owners_by_lookupcodes/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { ownerLookupcodes: string[], $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Name?: string, Projects?: { Id?: number, LookupCode?: string, Name?: string }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.ownerLookupcodes)) {
      missingRequiredInParams.push('\'ownerLookupcodes\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/ExcelMaterialImport/datasources/ds_get_owners_by_lookupcodes/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      ownerLookupcodes: string[]    }) {
        if(isNil(inParams.ownerLookupcodes)) {
          return true; 
        }
      return false;
    }
}
